import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SiteContent, RequestResult } from './models';

@Injectable({ providedIn: 'root' })
export class ContentService {
  private readonly base = '/api';

  constructor(private http: HttpClient) {}

  getContent(): Observable<SiteContent> {
    return this.http.get<SiteContent>(`${this.base}/content`);
  }

  submitRequest(body: unknown): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${this.base}/requests`, body);
  }
}
